module.exports = __webpack_public_path__ + "static/media/firebase.52e7aef2.png";